import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { HeartIcon, WarningIcon, DtcIcon, BatteryIcon, ToolIcon } from '../../../../common/icons';
import HealthFilter from './HealthFilter';

import './HealthsFilter.css';

@inject('translationsStore')
@observer
export default class HealthsFilter extends Component {
  componentDidMount = () => {
  };

  componentWillUnmount = () => {
  };

  toggleFilter = (name) => {
    this.props.onToggleFilter(name);
  };

  isFilterSelected = name => !!this.props.filters[`${name}`];

  render() {
    const { translationsStore, carsFilters } = this.props;

    return (
      <div className={`HealthsFilter ${this.props.visibleFilters ? 'filtersOpen' : 'filtersClosed'}`} style={this.props.style}>
        <HealthFilter
          selected={this.isFilterSelected('disconnected')}
          onClick={() => { this.toggleFilter('disconnected') }}
          disabled={carsFilters.disconnected === 0}
          icon={<HeartIcon />}
          label={translationsStore.translate('healtsfilter.labels.disconnessi')}
          number={carsFilters.disconnected}
          name="disconnected"
        />
        <HealthFilter
          selected={this.isFilterSelected('withAlarms')}
          onClick={() => { this.toggleFilter('withAlarms') }}
          disabled={carsFilters.withAlarms === 0}
          icon={<WarningIcon style={{ marginBottom: '5px' }} />}
          label={translationsStore.translate('healtsfilter.labels.allarmi')}
          number={carsFilters.withAlarms}
          name="withAlarms"
        />
        <HealthFilter
          selected={this.isFilterSelected('withDtcs')}
          onClick={() => { this.toggleFilter('withDtcs') }}
          disabled={carsFilters.withDtcs === 0}
          icon={<DtcIcon />}
          label={translationsStore.translate('healtsfilter.labels.dtc')}
          number={carsFilters.withDtcs}
          name="withDtcs"
        />
        <HealthFilter
          selected={this.isFilterSelected('withBatteryDown')}
          /* onClick={() => { this.toggleFilter('withBatteryDown') }} */
          /* disabled={carsFilters.withBatteryDown === 0} */
          disabled={true}
          icon={<BatteryIcon />}
          label={translationsStore.translate('healtsfilter.labels.battery')}
          number={carsFilters.withBatteryDown}
          name="withBatteryDown"
        />
        <HealthFilter
          selected={this.isFilterSelected('withMaintenance')}
          onClick={() => { this.toggleFilter('withMaintenance') }}
          disabled={carsFilters.withMaintenance === 0}
          icon={<ToolIcon />}
          label={translationsStore.translate('healtsfilter.labels.manutenzioni')}
          number={carsFilters.withMaintenance}
          name="withMaintenance"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/HealthsFilter/HealthsFilter.js